import { gql } from '@apollo/client'
import { CreatorForBrandFragment, CreatorFragment } from './creators'
import { CampaignFragment } from '../campaigns'
import {
  CollaborationForBrandFragment,
  CollaborationFragment,
} from './collaborations'

export const ClipFragment = gql`
  fragment ClipFragment on Clip {
    id
    createdAt
    updatedAt
    type
    hook
    addon

    video {
      url
      name
    }

    thumbnail {
      url
      name
    }

    creator {
      ...CreatorFragment
    }
    campaign {
      ...CampaignFragment
    }
    collaboration {
      ...CollaborationFragment
    }
  }
  ${CreatorFragment}
  ${CampaignFragment}
  ${CollaborationFragment}
`

export const ClipForBrandFragment = gql`
  fragment ClipForBrandFragment on Clip {
    id
    createdAt
    updatedAt
    type
    hook
    addon

    video {
      url
      name
    }

    thumbnail {
      url
      name
    }

    smallThumbnail {
      url
      name
    }

    creator {
      ...CreatorForBrandFragment
    }
    campaign {
      ...CampaignFragment
    }
    collaboration {
      ...CollaborationForBrandFragment
    }
  }
  ${CreatorForBrandFragment}
  ${CampaignFragment}
  ${CollaborationForBrandFragment}
`
